import { DateObject } from "./DateObject";
import { Time } from "./Time";

const DateTimeType = Symbol();

export class DateTime {
    [DateTimeType]: any;

    readonly date: DateObject;
    readonly time: Time;

    private constructor(date: DateObject, time: Time) {
        this.date = date;
        this.time = time;
    }

    format(delimiter: string = "-"): string {
        return `${this.date.format(delimiter)} ${this.time.format()}`;
    }

    isBeforeDate(date: DateObject): boolean {
        return this.date.isLessThan(date);
    }

    isAfterDate(date: DateObject): boolean {
        return this.date.isGreaterThan(date);
    }

    static fromString(str: string): DateTime {
        const date = DateObject.fromString(str.substr(0, 10));
        const time = Time.fromString(str.substr(11, 8));
        return new DateTime(date, time);
    }

    static from(date: DateObject, time: Time): DateTime {
        return new DateTime(date, time);
    }

    static startOfDate(date: DateObject): DateTime {
        return new DateTime(date, Time.fromNothing());
    }

    static now(): DateTime {
        const today = DateObject.today();
        const currentTime = Time.now();
        return new DateTime(today, currentTime);
    }

    static sortAsc(dateTime: DateTime, nextDateTime: DateTime): number {
        if (dateTime.format() < nextDateTime.format()) {
            return -1;
        } else if (dateTime.format() > nextDateTime.format()) {
            return 1;
        } else {
            return 0;
        }
    }

    static sortDesc(dateTime: DateTime, nextDateTime: DateTime): number {
        if (dateTime.format() < nextDateTime.format()) {
            return 1;
        } else if (dateTime.format() > nextDateTime.format()) {
            return -1;
        } else {
            return 0;
        }
    }
}
